import "./instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import App from "./App";
import LandingPage from "./pages/LandingPage";
import StudentLandingPage from "./pages/StudentLandingPage";
import AboutPage from "./pages/AboutPage";
import PricingPage from "./pages/PricingPage";
import EducatorOnboardingPage from "./pages/EducatorOnboardingPage";
import AttendancePage from "./pages/AttendancePage";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import VerifyOtpPage from "./pages/VerifyOtpPage";
import WaitlistedPage from "./pages/WaitlistedPage";
import CountryAcknowledgementModal from "./components/CountryAcknowledgementModal";
import MetaUpdater from "./components/MetaUpdater";

import "./styles/tailwind.css";

// Sentry (GlitchTip) instrumentation is initialised in `./instrument`.

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <MetaUpdater />
      <Routes>
        <Route path="/attendance/:attendanceId" element={<AttendancePage />} />
        <Route path="/app/*" element={<App />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/verify" element={<VerifyOtpPage />} />
        <Route path="/waitlisted" element={<WaitlistedPage />} />
        <Route path="/educators/onboarding" element={<EducatorOnboardingPage />} />
        <Route path="/students" element={<StudentLandingPage />} />
        <Route path="/" element={<LandingPage />} />
      </Routes>
      {/* Acknowledgement of Country */}
      <CountryAcknowledgementModal />
    </BrowserRouter>
  </React.StrictMode>
);
